export const GET_FLOATING_IMAGE = "GET_FLOATING_IMAGE";
export const POST_FLOATING_IMAGE = "POST_FLOATING_IMAGE";
export const SHOW_FLOATING_IMAGE = "SHOW_FLOATING_IMAGE";
export const UPDATE_FLOATING_IMAGE = "UPDATE_FLOATING_IMAGE";
export const UPDATE_STATUS_FLOATING_IMAGE = "UPDATE_STATUS_FLOATING_IMAGE";
export const DELETE_FLOATING_IMAGE = "DELETE_FLOATING_IMAGE";